
export default {
  async asyncData({ $prismic, params, error }) {
    try {
      const { results: categories } = await $prismic.api.query(
        '[at(document.type, "categories")]'
      )

      const category = categories.find((category) =>
        category.slugs.includes(params.slug)
      )

      const { data: selectedArticles } = await $prismic.api.getByID(
        'YUs2mRAAACIA3XAd',
        {
          fetchLinks: [
            'news_and_guides.category',
            'categories.category',
            'news_and_guides.featured_image',
            'news_and_guides.title',
            'news_and_guides.subtitle',
          ],
        }
      )

      const { results: articles, total_results_size: totalResultsSize } =
        await $prismic.api.query(
          [
            '[at(document.type, "news_and_guides")]',
            `[at(my.news_and_guides.category, "${category.id}")]`,
          ],
          {
            fetchLinks: 'categories.category',
            orderings:
              '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
            pageSize: 9,
          }
        )

      return {
        category,
        articles,
        categories,
        totalResultsSize,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Category not found' })
    }
  },

  data() {
    return {
      showFilters: false,
    }
  },

  head() {
    return {
      title: `${this.category.data.category} | Nurole News & Guides`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Read our latest news articles and expert guides on ${this.category.data.category}`,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `Read our latest news articles and expert guides on ${this.category.data.category}`,
        },
      ],
    }
  },

  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters
    },

    async loadMore() {
      const { results } = await this.$prismic.api.query(
        [
          '[at(document.type, "news_and_guides")]',
          `[at(my.news_and_guides.category, "${this.category.id}")]`,
        ],
        {
          fetchLinks: 'categories.category',
          orderings:
            '[my.news_and_guides.publish_date_override desc, document.last_publication_date desc]',
          pageSize: 9,
          page: this.articles.length / 9 + 1,
        }
      )

      this.articles = this.articles.concat(results)
    },
  },
}
